import { Component, Inject, OnInit } from '@angular/core'
import { Rental, SaveForm } from '@tokeet-frontend/tv3-platform'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { select, Store } from '@ngrx/store'
import * as fromRoot from '@tv3/store/state'
import { selectAllRentals } from '@tokeet-frontend/tv3-platform'
import { Destroyable, untilDestroy } from '@tokeet-frontend/tv3-platform'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

export interface SelectRentalDialogConfig {
  rentals?: Rental[]
  selectedId?: string
  selectedIds?: string[]
  multiple?: boolean
  selectOnChange?: boolean
  title?: string
  help?: string
  required?: boolean
  buttonIcon?: string
  buttonText?: string
}

@Component({
  selector: 'app-select-rental-dialog',
  templateUrl: './select-rental-dialog.component.html',
  host: { class: 'modal-content' },
  styleUrls: ['./select-rental-dialog.component.scss'],
})
export class SelectRentalDialogComponent extends Destroyable implements OnInit {
  config = {
    title: 'Select Rental',
    help: 'Please select a rental from the list above.',
    buttonText: 'Select',
    multiple: false,
    required: true,
  } as SelectRentalDialogConfig

  form = this.fb.group({
    rental: [[]],
  })

  rentals: Rental[] = []

  constructor(
    public dialogRef: MatDialogRef<SelectRentalDialogComponent>,
    private fb: FormBuilder,
    private store: Store<fromRoot.State>,
    @Inject(MAT_DIALOG_DATA) public data: { config: SelectRentalDialogConfig }
  ) {
    super()
  }

  ngOnInit() {
    this.config = { ...this.config, ...this.data.config }

    if (this.data.config?.rentals) {
      this.rentals = this.data.config.rentals
    } else {
      this.store.pipe(select(selectAllRentals), untilDestroy(this)).subscribe((rentals) => {
        this.rentals = rentals
      })
    }
    if (this.config.required) {
      this.form.get('rental')?.addValidators(Validators.required)
    }

    const initialSelection = this.config.multiple ? this.config.selectedIds || [] : this.config.selectedId
    this.form.patchValue({ rental: initialSelection })
  }

  onSelectedRentals(rentals: Rental[]) {
    if (this.config.selectOnChange && !this.config.multiple && rentals?.length === 1) {
      this.dialogRef.close(rentals[0])
    }
  }

  close() {
    this.dialogRef.close()
  }

  @SaveForm()
  save(form: FormGroup) {
    const formValues = this.form.getRawValue()
    const selectedIds = Array.isArray(formValues.rental) ? formValues.rental : [formValues.rental]
    const selectedRentals = this.rentals.filter((rental) => selectedIds.includes(rental.id))
    this.dialogRef.close(this.config.multiple ? selectedRentals : selectedRentals[0])
  }
}
